import { ModelService } from '@philips-internal/oswald-ui-core/lib/services';
import moment from 'moment';
var DateFormatType;
(function (DateFormatType) {
    DateFormatType["DATE"] = "date";
    DateFormatType["DATE_PICKER"] = "datepicker";
    DateFormatType["FULL"] = "full";
    DateFormatType["FULL_DATE"] = "fullDate";
    DateFormatType["LONG_DATE"] = "longDate";
    DateFormatType["MEDIUM"] = "medium";
    DateFormatType["MEDIUM_DATE"] = "mediumDate";
    DateFormatType["MEDIUM_TIME"] = "mediumTime";
    DateFormatType["SHORT"] = "short";
    DateFormatType["SHORT_DATE"] = "shortDate";
    DateFormatType["SHORT_MONTH"] = "shortMonth";
    DateFormatType["SHORT_TIME"] = "shortTime";
    DateFormatType["SHORT_YEAR"] = "shortYear";
    DateFormatType["SPINNER"] = "spinner";
    DateFormatType["TIME_SPINNER"] = "timeSpinner";
    DateFormatType["TIME_STAMP"] = "timestamp";
})(DateFormatType || (DateFormatType = {}));
function format(value, dateFormatType) {
    return ModelService.format('date', value, { type: dateFormatType });
}
function date(value) {
    return format(moment(value).utc().format('L'), DateFormatType.DATE);
}
function datePicker(value) {
    return format(value, DateFormatType.DATE_PICKER);
}
function full(value) {
    return format(value, DateFormatType.FULL);
}
function fullDate(value) {
    return format(value, DateFormatType.FULL_DATE);
}
function longDate(value) {
    return format(value, DateFormatType.LONG_DATE);
}
function medium(value) {
    return format(value, DateFormatType.MEDIUM);
}
function mediumDate(value) {
    return format(value, DateFormatType.MEDIUM_DATE);
}
function mediumTime(value) {
    return format(value, DateFormatType.MEDIUM_TIME);
}
function short(value) {
    return format(value, DateFormatType.SHORT);
}
function shortDate(value) {
    return format(moment(value).utc().format('L'), DateFormatType.SHORT_DATE);
}
function shortMonth(value) {
    return format(moment(value).utc().format('L'), DateFormatType.SHORT_MONTH);
}
function shortTime(value) {
    return format(moment(value).format('LT'), DateFormatType.SHORT_TIME);
}
function shortYear(value) {
    return format(value, DateFormatType.SHORT_YEAR);
}
function spinner(value) {
    return format(value, DateFormatType.SPINNER);
}
function timeSpinner(value) {
    return format(value, DateFormatType.TIME_SPINNER);
}
function timeStamp(value) {
    return format(value, DateFormatType.TIME_STAMP);
}
function timefieldToLocalTimezone(timefield) {
    const time = timefield.split(':');
    return moment().hour(parseInt(time[0])).minute(parseInt(time[1])).add(moment().utcOffset(), 'minute').format('LT');
}
function timeFieldToTimezone(timeField) {
    const time = timeField.split(':');
    return moment().hour(time[0] ? parseInt(time[0]) : 0)
        .minute(time[1] ? parseInt(time[1]) : 0)
        .second(time[2] ? parseInt(time[2]) : 0)
        .subtract(moment().utcOffset(), 'minute')
        .format('LTS');
}
const DateFormatterUtil = {
    date,
    datePicker,
    full,
    fullDate,
    longDate,
    medium,
    mediumDate,
    mediumTime,
    short,
    shortDate,
    shortMonth,
    shortTime,
    shortYear,
    spinner,
    timefieldToLocalTimezone,
    timeFieldToTimezone,
    timeSpinner,
    timeStamp,
};
export default DateFormatterUtil;
//# sourceMappingURL=date-formatter-util.js.map